// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IOcrAddressResponseDto } from './IOcrAddressResponseDto';
import {
    IOcrAddressResponseDtoFromJSON,
    IOcrAddressResponseDtoFromJSONTyped,
    IOcrAddressResponseDtoToJSON,
    IOcrAddressResponseDtoToJSONTyped,
} from './IOcrAddressResponseDto';

/**
 * 
 * @export
 * @interface IOcrProviderOptionDto
 */
export interface IOcrProviderOptionDto {
    /**
     * 
     * @type {number}
     * @memberof IOcrProviderOptionDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IOcrProviderOptionDto
     */
    name?: string;
    /**
     * 
     * @type {IOcrAddressResponseDto}
     * @memberof IOcrProviderOptionDto
     */
    address?: IOcrAddressResponseDto;
    /**
     * 
     * @type {boolean}
     * @memberof IOcrProviderOptionDto
     */
    is_suggested?: boolean;
}

/**
 * Check if a given object implements the IOcrProviderOptionDto interface.
 */
export function instanceOfIOcrProviderOptionDto(value: object): value is IOcrProviderOptionDto {
    return true;
}

export function IOcrProviderOptionDtoFromJSON(json: any): IOcrProviderOptionDto {
    return IOcrProviderOptionDtoFromJSONTyped(json, false);
}

export function IOcrProviderOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrProviderOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'address': json['address'] == null ? undefined : IOcrAddressResponseDtoFromJSON(json['address']),
        'is_suggested': json['is_suggested'] == null ? undefined : json['is_suggested'],
    };
}

export function IOcrProviderOptionDtoToJSON(json: any): IOcrProviderOptionDto {
    return IOcrProviderOptionDtoToJSONTyped(json, false);
}

export function IOcrProviderOptionDtoToJSONTyped(value?: IOcrProviderOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'address': IOcrAddressResponseDtoToJSON(value['address']),
        'is_suggested': value['is_suggested'],
    };
}

